'use client';
import { motion, useReducedMotion, useScroll, useSpring } from 'motion/react';
import { useEffect, useState } from 'react';

/**
 * Page scroll progress — the motion.dev signature: a thin brand-primary line
 * pinned to the very top of the viewport, filling left → right with a spring.
 */
export function ScrollProgress() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional post-mount flip to opt into client-only motion variant
    setHydrated(true);
  }, []);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 28, restDelta: 0.001 });

  if (!hydrated || reduce) return null;

  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-[60] h-[3px] origin-left bg-primary"
      style={{ scaleX }}
    />
  );
}
